import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  drawer: {
    flexShrink: 0,
    zIndex:theme.zIndex.drawer,
    // marginLeft:"150px",
    "&>*":{
      marginLeft: 30,

      "@media screen and (max-width: 768px)": {
        marginLeft: 16
      },

      "@media screen and (max-width: 480px)": {
        marginLeft: 0,

        '& .MuiPaper-root.MuiPaper-elevation': {
          position: "static"
        }
      },
    }
    
  },
  toolbar: theme.mixins.toolbar,
  dragger: {
    // marginLeft:"150px",
    userSelect:"none",
    width: "5px",
    cursor: "default",
    padding: "4px 0 0",
    borderTop: "1px solid #ddd",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 100,
    backgroundColor: "#f5f5f5",
    pointerEvents: "none",

    "@media screen and (max-width: 768px)": {
      width: 2
    },

    "@media screen and (max-width: 480px)": {
      width: 0,
    }

  }
}));

export default useStyles;
